import React from 'react';
import {
  CustomSolution1,
  CustomSolution2,
  CustomSolution3,
  CustomSolution4,
  CustomSolution5,
} from '../../assets/images/solution';
import OurPortfolio from '../../components/Home/OurPortfolio';
import { dataPortfolio } from '../Homepage/homepageData';

const CustomSolution = () => {
  return (
    <div className='pt-28'>
      <section className='h-full px-8 sm:px-10 xl:px-0 max-w-[1200px] m-auto w-full py-16 sm:py-20 flex flex-col gap-24 md:gap-0'>
        <div className='flex flex-col md:flex-row items-center md:gap-12 '>
          <div className='flex flex-col gap-8'>
            <p className='font-bold text-2xl sm:text-4xl'>
              Solusi Kustom: Dirancang Sesuai Kebutuhan Unik Bisnis Anda
            </p>
            <p className='text-base sm:text-xl'>
              Layanan Solusi Kustom kami dirancang untuk menghadirkan produk
              yang secara tepat dan efisien mengatasi tantangan bisnis Anda.
            </p>
          </div>
          <img src={CustomSolution1} alt={'CustomSolution1'} className='' />
        </div>

        <div className='flex flex-col md:flex-row-reverse items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Sepenuhnya Dapat Dicustom
            </p>
            <p className=''>
              Setiap aspek produk dirancang khusus untuk bisnis Anda, memastikan
              sesuai dengan tujuan dan alur kerja yang ada.
            </p>
          </div>
          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={CustomSolution2} alt={'CustomSolution2'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Pengembangan yang Skalabel
            </p>
            <p className=''>
              Solusi kami dirancang untuk berkembang seiring dengan pertumbuhan
              bisnis Anda, menjamin efisiensi dan adaptabilitas jangka panjang.{' '}
            </p>
          </div>
          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={CustomSolution3} alt={'CustomSolution3'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row-reverse items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>Siap Integrasi</p>
            <p className=''>
              Kami menciptakan produk yang terintegrasi dengan mulus ke dalam
              sistem yang sudah Anda gunakan, memastikan transisi yang lancar
              dan bebas hambatan.
            </p>
          </div>
          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={CustomSolution4} alt={'CustomSolution4'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              User-Centric Design
            </p>
            <p className=''>
              We focus on delivering products that are intuitive and easy to
              use, enhancing user experience and satisfaction.
            </p>
          </div>
          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={CustomSolution5} alt={'CustomSolution5'} />
          </div>
        </div>

        <OurPortfolio
          data={dataPortfolio
            .map((data, i) => i < 3 && data)
            .filter((data) => data)}
        />

        <div className='flex flex-col items-center sm:p-10 w-full max-w-[666px]-center gap-10'>
          <p className='font-bold text-2xl sm:text-3xl'>
            Solusi Yang Kami Tawarkan
          </p>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-between gap-12 sm:gap-6 bg-[#F7F7F7] p-8 md:p-12 '>
            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Pengembangan Perangkat Lunak</p>
              <p className='text-[#898989]'>
                Perangkat lunak khusus yang dirancang untuk mengatasi tantangan
                bisnis tertentu, mulai dari alat internal hingga platform yang
                berfokus pada pelanggan.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Aplikasi Mobile</p>
              <p className='text-[#898989]'>
                Kami mengembangkan aplikasi mobile yang meningkatkan
                keterlibatan pelanggan, memperlancar operasional, atau
                menghadirkan layanan baru.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Aplikasi Web</p>
              <p className='text-[#898989]'>
                Mulai dari platform e-commerce, sistem pemesanan, hingga alat
                manajemen konten, kami menyediakan solusi web yang dibuat khusus
                untuk kebutuhan Anda.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Integrasi Sistem</p>
              <p className='text-[#898989]'>
                Kami membantu mengintegrasikan alat dan teknologi baru ke dalam
                infrastruktur yang sudah ada, menciptakan ekosistem yang mulus
                untuk bisnis Anda.
              </p>
            </div>
          </div>
        </div>

        <div className='flex flex-col items-center sm:p-10 w-full max-w-[666px]-center gap-10'>
          <p className='font-bold text-2xl sm:text-3xl'>Alur Kerja Kami</p>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-between gap-12 sm:gap-6 bg-[#F7F7F7] p-8 md:p-12 '>
            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Konsultasi</p>
              <p className='text-[#898989]'>
                Kami memulai dengan memahami tantangan bisnis Anda dan
                mengidentifikasi area di mana AI dapat memberikan dampak yang
                signifikan.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Desain Solusi Khusus</p>
              <p className='text-[#898989]'>
                Tim ahli kami merancang solusi AI yang dibuat khusus, dirancang
                untuk terintegrasi dengan mulus ke dalam sistem yang sudah Anda
                miliki.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Penerapan & Integrasi</p>
              <p className='text-[#898989]'>
                Kami memastikan implementasi berjalan lancar dan memberikan
                dukungan selama masa transisi.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Dukungan Berkelanjutan</p>
              <p className='text-[#898989]'>
                Setelah peluncuran, kami menyediakan layanan pemeliharaan,
                pembaruan, dan optimasi untuk memastikan solusi AI Anda terus
                memberikan nilai maksimal.
              </p>
            </div>
          </div>
        </div>
        {/* <div className="py-24">
                    <FAQ />
                </div> */}
      </section>
    </div>
  );
};

export default CustomSolution;
